var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "categories-filter" }, [
    _c("div", { staticClass: "title-container", on: { click: _vm.collapse } }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Product Type "),
        !_vm.selectedCategories.includes("View All")
          ? _c("span", [
              _vm._v("(" + _vm._s(_vm.selectedCategories.length) + ")")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "icon" }, [_vm._v(_vm._s(_vm.plusIcon))])
    ]),
    _vm._v(" "),
    !_vm.collapsed
      ? _c(
          "div",
          { staticClass: "checkbox-container" },
          _vm._l(_vm.currentCategories, function(categories) {
            return _c(
              "div",
              {
                key: categories.title,
                staticClass: "checkbox-button",
                on: {
                  click: function($event) {
                    return _vm.addCategory(categories.title)
                  }
                }
              },
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: {
                    value: categories.title,
                    checked: _vm.selectedCategories.includes(categories.title)
                  }
                }),
                _vm._v(" "),
                _c("p", { class: categories.title == "Sale" ? "red" : "" }, [
                  _vm._v(_vm._s(categories.title))
                ])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }